<div>
    <mat-spinner [diameter]="diameter"></mat-spinner>
</div>
